// import 'react-phone-input-2/lib/style.css';
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import { Box, Stack, Typography } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { styled } from "@mui/material/styles";
import { useSettingsContext } from "../settings";
import { useTheme, alpha } from "@mui/material/styles";
import { removeCodeFromPhone } from "src/utils/common";

// To avoid re-rendering of this component on every input change, pull it outside of the PhoneNumberInput component
const StyledPhoneInput = styled(PhoneInput)(({ theme, ownerState }) => ({
  "&.react-tel-input .special-label": {
    backgroundColor:
      ownerState.themeMode === "dark" ? theme?.palette?.background?.paper : "",
    color:
      ownerState.themeMode === "dark"
        ? theme.palette.text.primary
        : theme.palette.text.disabled,
  },
  "&.react-tel-input .form-control": {
    border: `1px solid ${alpha(theme.palette.grey[500], 0.32)}`,
    boxShadow: `0px 0px 0px 0px ${theme.palette.text.primary}`,
    color: theme.palette.text.primary,
  },
  "&.react-tel-input .form-control:focus": {
    border: `1px solid ${
      ownerState.themeMode === "dark"
        ? theme.palette.text.primary
        : theme.palette.text.primary
    }`,
    boxShadow: `0px 0px 0px 0px ${theme.palette.text.primary}`,
  },
  "&.react-tel-input .form-control:hover": {
    border: `1px solid ${
      ownerState.themeMode === "dark"
        ? theme.palette.text.primary
        : theme.palette.text.primary
    }`,
    boxShadow: `0px 0px 0px 0px ${theme.palette.text.primary}`,
  },
  "&.react-tel-input .country-list": {
    border: `1px solid ${
      ownerState.themeMode === "dark"
        ? theme.palette.text.disabled
        : theme.palette.text.disabled
    }`,
    padding: "8px",
    boxShadow: `0px 0px 0px 0px ${theme.palette.text.primary}`,
    backgroundColor:
      ownerState.themeMode === "dark" ? theme?.palette?.background?.paper : "",
    color: theme.palette.text.primary,
  },

  "&.react-tel-input .country-list .country": {
    borderRadius: "8px",
  },

  "&.react-tel-input .country-list .country:hover": {
    backgroundColor:
      ownerState.themeMode === "dark" ? "rgba(145, 158, 171, 0.16)" : "",
  },

  "&.react-tel-input .country-list .country.highlight": {
    backgroundColor:
      ownerState.themeMode === "dark" ? "rgba(145, 158, 171, 0.16)" : "",
    color: theme.palette.text.primary,
  },
}));

export default function PhoneNumberInput({
  onChange = () => {},
  country = "",
  onChangeCountry = () => {},
  name,
  label = "Phone No.",
  bgColor = "#fff",
  onlyCountries = ["us", "br"],
}) {
  const { control, setError, clearErrors } = useFormContext();
  const theme = useTheme();
  const { themeMode } = useSettingsContext();

  // Use provided country or default to first country in onlyCountries list
  let userCountryCode = country;
  if (userCountryCode === "") {
    // Default to first country in the allowed list, or "us" if list is empty
    if (onlyCountries && onlyCountries.length > 0) {
      userCountryCode = onlyCountries[0];
    } else {
      userCountryCode = "us";
    }
  }
  return (
    <Box sx={{ width: "100%" }}>
      <Controller
        name={name}
        control={control}
        render={({ field, formState, fieldState: { error } }) => {
          const { dirtyFields, errors } = formState;
          console.log(dirtyFields, errors);
          return (
            <Stack
              sx={{
                gap: 1,
                "&.react-tel-input .form-control:focus": {
                  borderColor: "#69e781",
                  boxShadow: "0px 0px 0px 1px #69e781",
                },
              }}
            >
              <StyledPhoneInput
                ownerState={{
                  themeMode,
                }}
                onlyCountries={onlyCountries}
                country={userCountryCode}
                id={name}
                name={name}
                placeholder=""
                inputStyle={{
                  width: "100%",
                  height: "56px",
                  borderRadius: "8px",
                  backgroundColor:
                    themeMode === "dark"
                      ? theme?.palette?.background?.paper
                      : "",
                }}
                buttonStyle={{
                  borderRadius: "8px 2px 2px 8px",
                  borderRight: 0,
                }}
                // enableSearch
                label
                specialLabel={label}
                countryCodeEditable={false}
                value={field?.value?.toString()}
                onBlur={(a, b, c) => {
                  console.log(a, b, c, field);
                  if (
                    removeCodeFromPhone(field?.value?.toString(), b.dialCode)
                      .length < 7
                  ) {
                    setError(`${name}`, {
                      type: "manual",
                      message: "Phone number require min. 7 digit",
                    });
                  } else if (
                    removeCodeFromPhone(field?.value?.toString(), b.dialCode)
                      .length > 20
                  ) {
                    setError(`${name}`, {
                      type: "manual",
                      message: "Phone number require max. 20 digit",
                    });
                  } else {
                    clearErrors(`${name}`);
                  }
                }}
                isValid={(value, country) => {
                  return true;
                }}
                onChange={(e, countryDetail) => {
                  if (
                    `${e}`.length ===
                    10 + `${countryDetail.dialCode}`.length
                  ) {
                    clearErrors(`${name}`);
                  }
                  onChangeCountry(countryDetail);
                  field.onChange(e);
                  onChange(e);
                }}
              />
              {!!error && (
                <Typography
                  sx={{ color: "error.main", ml: 2 }}
                  variant="caption"
                >
                  {error?.message || ""}
                </Typography>
              )}
            </Stack>
          );
        }}
      />
    </Box>
  );
}
